"use client";

import { FundsHeader } from "./components/FundsHeader";
import { FundsMain } from "./components/FundsMain";

export const FundsPageComponent = ({ filtersList, startList }) => {
  return (
    <>
      <FundsHeader />
      <FundsMain {...{ filtersList, startList }} />
    </>
  );
};
